import { ReactNode, createContext, useContext } from "react";
import { useNewSubscription } from "./new-subscription/new-subscription.hook";

const NewSubscriptionContext = createContext(
  {} as ReturnType<typeof useNewSubscription>
);
export function useNewSubscriptionContext() {
  return useContext(NewSubscriptionContext);
}

interface NewSubscriptionProviderProps {
  children: ReactNode;
}
export function NewSubscriptionProvider({
  children,
}: NewSubscriptionProviderProps) {
  return (
    <NewSubscriptionContext.Provider value={useNewSubscription()}>
      {children}
    </NewSubscriptionContext.Provider>
  );
}
